import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

/**
 * 履职清单模板的接口服务
 */
export class DutyListTemplateServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 模板分页列表
  public getTemplatePageList(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyRuleListTemplate';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 模板全部列表
  public getTemplateAllList(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyRuleListTemplate/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增模板
  public addTemplate(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyRuleListTemplate';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 编辑模板
  public editTemplate(id: any, opts: object) {
    const url = serverUrl + `/api/yunnan/dutyRuleListTemplate/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 获取模板详情
  public getTemplateDetails(id: any) {
    const url = serverUrl + `/api/yunnan/dutyRuleListTemplate/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 删除模板
  public deleteTemplateList(idList: any) {
    if (idList instanceof Array) {
      idList = idList.join(',');
    }
    const url = serverUrl + '/api/yunnan/dutyRuleListTemplate?idList=' + idList;
    return this.rSerivce.serverObj.delete(url, {
      params: idList,
    });
  }
}
